import { createColumnHelper } from '@tanstack/react-table';

import { DockerContainer } from '../../../types';

export const columnHelper = createColumnHelper<DockerContainer>();
